module.exports = __webpack_public_path__ + "img/018.e1f67afc.png";